import { FC } from 'react';

import { IconCheckmark } from '@purpur/library/icon/checkmark';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { ESHOP_TEST_ID } from '@telialt/core-eshop/src/test/test-ids';

import { GiftOption } from '../model';
import { CopyLocalCode } from './CopyLocalCode';
import {
    Body,
    Extra,
    GiftPrice,
    GiftPriceOld,
    GiftSymbol,
    GiftTitle,
    Image,
    ReadOnlyCard,
    ReadOnlyCardGroup,
} from './GiftGroup.styles';
import { OpenGiftDetailsModalButton } from './OpenGiftDetailsModalButton';

type Props = { options: GiftOption[]; labelledBy?: string };

export const ReadOnlyGiftGroup: FC<Props> = ({ options, labelledBy }) => {
    const { t } = useTranslations();

    return (
        <ReadOnlyCardGroup data-test={ESHOP_TEST_ID.GIFT_ITEM_CHECKBOX} aria-labelledby={labelledBy}>
            {options.map(({ code, image, name, oldPriceCrossed, price, onOpenDetails }) => (
                <ReadOnlyCard key={code} aria-label={name}>
                    <GiftSymbol>
                        <IconCheckmark size="xs" />
                    </GiftSymbol>
                    <Body>
                        <GiftTitle>{name}</GiftTitle>
                        <GiftPrice
                            data-test={ESHOP_TEST_ID.GIFT_ITEM_PRICE_BLOCK}
                            aria-label={`${t['eshop.product_page.price_accessible']} ${price}`}
                        >
                            <span aria-hidden={true}>{price}</span>
                        </GiftPrice>
                        {oldPriceCrossed && (
                            <GiftPriceOld
                                data-test={ESHOP_TEST_ID.GIFT_ITEM_OLD_PRICE_BLOCK}
                                aria-label={`${t['eshop.product_page.old_price_accessible']} ${oldPriceCrossed}`}
                            >
                                <span aria-hidden={true}>{oldPriceCrossed}</span>
                            </GiftPriceOld>
                        )}
                        <CopyLocalCode>{code}</CopyLocalCode>
                    </Body>
                    <Image {...image} />
                    <Extra>
                        <OpenGiftDetailsModalButton onClick={onOpenDetails} />
                    </Extra>
                </ReadOnlyCard>
            ))}
        </ReadOnlyCardGroup>
    );
};
